import { CommandModel } from './command.model';

export class GeneratePdfCommandV1Model extends CommandModel {
  type = 'com.rbinternational.merlin.smeon.commands.form.GeneratePdfCommandV1';
  formJson: string;
  documentId: string;
}
